// Real, source-verified alumni. Facts limited to what the listed official sources support.
export const successStories = [
  {
    id: "kevin",
    name: "Kevin Lijaya Lukman",
    avatar: "https://customer-assets-lxgj4vgw.emergentagent.net/job_pathway-ready/artifacts/258zueio_01_Kevin_Lijaya_Lukman.jpg.jpeg",
    scholarship: "LPDP",
    university: "Imperial College London",
    program: "Metals and Energy Finance MSc",
    country: "Inggris",
    story: "Kevin Lijaya Lukman adalah penerima beasiswa LPDP yang menempuh program Metals and Energy Finance MSc di Imperial College London, Inggris. Kisah perjuangannya didokumentasikan secara resmi oleh LPDP.",
    source: "Sumber resmi LPDP",
    sourceUrl: "https://lpdp.kemenkeu.go.id/informasi/berita/mental-juara-kevin-lijaya-lukman-dari-gagal-ielts-tiga-kali-hingga-tesis-terbaik-se-inggris-raya/",
  },
  {
    id: "aishah",
    name: "Aishah Prastowo",
    avatar: "https://customer-assets-lxgj4vgw.emergentagent.net/job_pathway-ready/artifacts/16e86d96_02_Aishah_Prastowo.jpg.jpeg",
    scholarship: "LPDP",
    university: "University of Oxford",
    program: "Engineering Science (DPhil)",
    country: "Inggris",
    story: "Aishah Prastowo menempuh studi doktoral (DPhil) Engineering Science di University of Oxford, Inggris, melalui beasiswa LPDP. Menurut LPDP, setelah lulus ia memilih mengabdi sebagai guru SMA di Yogyakarta.",
    source: "Sumber resmi LPDP",
    sourceUrl: "https://lpdp.kemenkeu.go.id/en/informasi/berita/aishah-prastowo-lulusan-s3-oxford-yang-pilih-jadi-guru-sma-di-yogyakarta/",
  },
  {
    id: "hans",
    name: "Hans Juliano",
    avatar: "https://customer-assets-lxgj4vgw.emergentagent.net/job_pathway-ready/artifacts/ntn1i849_03_Hans_Juliano.jpg%20.jpeg",
    scholarship: "NYCU Scholarship",
    university: "National Yang Ming Chiao Tung University",
    program: "Electrical Engineering and Computer Science (fokus Nanoelectronics)",
    country: "Taiwan",
    story: "Hans Juliano menerima NYCU Scholarship untuk program Electrical Engineering and Computer Science dengan fokus Nanoelectronics di National Yang Ming Chiao Tung University (NYCU), Taiwan.",
    source: "Sumber resmi NYCU",
    sourceUrl: "https://www.nycu.edu.tw/oia/en/app/data/view?id=777&module=nycu0011&serno=23bbbcd2-a55d-4ec4-a93b-c3b6bc3aa48d",
  },
  {
    id: "iradani",
    name: "Iradani Katalia",
    avatar: "https://customer-assets-lxgj4vgw.emergentagent.net/job_pathway-ready/artifacts/qxavpxv9_04_Iradani_Katalia.jpg%20.webp",
    scholarship: "DAAD",
    university: "Universität Duisburg-Essen",
    program: "Water Science",
    country: "Jerman",
    story: "Iradani Katalia menempuh program Water Science di Universität Duisburg-Essen, Jerman, dengan dukungan beasiswa DAAD. Kisahnya tercatat dalam e-book alumni DAAD Indonesia.",
    source: "DAAD Indonesia",
    sourceUrl: "https://www.daad-indonesia.org/files/2025/06/DAAD-Alumni-E-book_35-Years-DAAD-Indonesia.pdf",
  },
  {
    id: "dayu",
    name: "Dayu Nirma",
    avatar: "https://customer-assets-lxgj4vgw.emergentagent.net/job_pathway-ready/artifacts/kglr71vf_05_Dayu_Nirma.jpg.jpeg",
    scholarship: "Chevening",
    university: "London School of Economics and Political Science",
    program: "MSc Public Management and Governance",
    country: "Inggris",
    story: "Dayu Nirma meraih beasiswa Chevening untuk program MSc Public Management and Governance di London School of Economics and Political Science (LSE), Inggris.",
    source: "Sumber resmi Chevening",
    sourceUrl: "https://www.chevening.org/news/building-a-strong-chevening-family-in-indonesia/",
  },
];
